

















































































































import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import {
  BibliographyRealDetailCollection,
  defaultBibliographyRealDetailCollection,
  SystemCode
} from '@/api'
import {
  CollectionStatus,
  OrderIdMaxDigits,
  SortOrder,
  UserDetailTabType
} from '@/types'
import { orderBy } from 'lodash'
import dayjs from 'dayjs'
import { Emit } from '@/node_modules/nuxt-property-decorator'

export interface BibliographyDetailCollectionTableItem
  extends BibliographyRealDetailCollection {
  isOrder: boolean
}

export interface ShelfTypeItem {
  shelfType: SystemCode
  holdingBranch: SystemCode
}

export const defaultBibliographyDetailCollectionTableItem = (): BibliographyDetailCollectionTableItem => ({
  isOrder: false,
  ...defaultBibliographyRealDetailCollection()
})

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'collectionOrderNo',
        headerText: '資料／発注番号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '6',
    resizable: true,
    items: [
      {
        name: 'holdingBranchCode',
        headerText: '所蔵館',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    items: [
      {
        name: 'callNo',
        headerText: '請求記号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '6',
    resizable: true,
    items: [
      {
        name: 'shelfType',
        headerText: '配架',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    items: [
      {
        name: 'collectionType',
        headerText: '資料区分',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '6',
    resizable: true,
    items: [
      {
        name: 'status',
        headerText: '状態',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '6',
    resizable: true,
    items: [
      {
        name: 'handlingType',
        headerText: '取扱',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '6',
    resizable: true,
    items: [
      {
        name: 'appendixCode',
        headerText: '付録',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    items: [
      {
        name: 'dueAndProcessedDate',
        headerText: '処理日／返却日',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '6',
    resizable: true,
    items: [
      {
        name: 'processedBranchCode',
        headerText: '処理館',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '6',
    resizable: true,
    items: [
      {
        name: 'forwardingBranchCode',
        headerText: '回送館',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '11',
    resizable: true,
    items: [
      {
        name: 'userId',
        headerText: '利用者番号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '5',
    resizable: true,
    items: [
      {
        name: 'memo',
        headerText: '',
        align: 'center'
      }
    ]
  }
]

@Component({
  components: { DataTable }
})
export default class BibliographyDetailCollectionTable extends ComponentVue {
  @Prop({
    type: Array,
    required: true
  })
  items!: BibliographyDetailCollectionTableItem[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @PropSync('selected', {
    type: Object,
    required: true
  })
  selectedItem!: BibliographyDetailCollectionTableItem

  @Prop({
    type: Boolean,
    default: false
  })
  lendAppendix!: boolean

  sortName: string = ''

  sortOrder: SortOrder = ''

  get orderIdMaxDigits(): number {
    return OrderIdMaxDigits
  }

  get sortedItems(): BibliographyDetailCollectionTableItem[] {
    if (this.sortName) {
      return orderBy<BibliographyDetailCollectionTableItem>(
        this.items,
        (item: BibliographyDetailCollectionTableItem) => {
          const propertyValue =
            item[this.sortName as keyof BibliographyDetailCollectionTableItem]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (this.sortName === 'collectionOrderNo') {
            return item.isOrder
              ? String(item.id).padStart(this.orderIdMaxDigits, '0')
              : item.collectionNo
          }
          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  get cols(): Col[] {
    return COLS
  }

  isOverDueDate(value: string): boolean {
    return value < dayjs().format('YYYYMMDD')
  }

  onClickRow(index: number): void {
    if (this.selectedItem === this.sortedItems[index]) {
      return
    }

    this.selectedItem = this.sortedItems[index]
    this.$emit('selected')
  }

  onSort(sortColumn: SortColumn): void {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  onClickShelf(item: BibliographyDetailCollectionTableItem): void {
    const shelfTypeItem: ShelfTypeItem = {
      shelfType: item.shelfType,
      holdingBranch: item.holdingBranchCode
    }
    this.$emit('click:shelf-type', shelfTypeItem)
  }

  openModalUserDetail(userId: string, status: SystemCode): void {
    let activeTab = UserDetailTabType.Basic
    if (status.code === CollectionStatus.Lending) {
      activeTab = UserDetailTabType.Lending
    } else if (status.code === CollectionStatus.ReceiveWaiting) {
      activeTab = UserDetailTabType.Reserved
    }

    this.$modalUserDetail.open({
      userId,
      initialActiveTab: activeTab
    })
  }

  @Emit('change:appendix-lend')
  onChangeAppendixLendCheckbox(index: number): number {
    // クリックした時にチェックを切り替えさせない為に下記の処理を施している
    this.sortedItems[index].appendixLendFlag = !this.sortedItems[index]
      .appendixLendFlag

    this.$nextTick(
      () =>
        (this.sortedItems[index].appendixLendFlag = !this.sortedItems[index]
          .appendixLendFlag)
    )

    return this.items.findIndex(item => item.id === this.sortedItems[index].id)
  }

  @Emit('memo')
  onClickMemo(id: number): number {
    return this.items.findIndex(item => item.id === id)
  }
}
